module.exports = __webpack_public_path__ + "static/media/intake-follow-up-and-outcomes-questionnaires-01@2x.4d8d5c84.png";